import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-step-one',
  templateUrl: './step-one.component.html',
  styleUrls: ['./step-one.component.scss']
})
export class StepOneComponent implements OnInit {

  isLoading: boolean = false;
  canNavigate: boolean = false;
  checkAllPointsConfigured: boolean = false;

  pageTitle: string;
  title: string;
  description: string;
  files: File[] = [];
  youtube: string;
  routeId = JSON.parse(localStorage.getItem('currentRouteId'));
  currentRoute: any;
  currentRoutePoints: any;

  constructor(private apiService: ApiService, private router: Router) { }

  ngOnInit(): void {
    if (this.routeId) {
      this.getPoints();
      this.currentRoute = JSON.parse(localStorage.getItem('userRoutes')).find(id => id.id === this.routeId);
      this.pageTitle = 'Édition du circuit ' + this.currentRoute.title;
      this.currentRoute.points = this.currentRoute.points.filter(function( point ) {
        return point.etat == 2;
      });
      if (this.currentRoute.points.length) {
        this.canNavigate = true;
      }
      this.title = this.currentRoute.title;
      this.description = this.currentRoute.description;
      this.youtube = this.currentRoute.youtube;
      if (this.currentRoute.medias.length) {
        this.currentRoute.medias.forEach((element, index) => {
          let format = element.url.substring(element.url.lastIndexOf('.') + 1);
          let name = element.url.substring(element.url.lastIndexOf('/') + 1);
          let file = dataURLtoFile('data:image/' + format + ';base64,' + element.data, name);
          this.files.push(file);
        });
      }
    } else {
      this.pageTitle = 'Création d\'un circuit';
    }
  }

  createRoute(lang, title, toStep, description?, youtube?) {
    this.isLoading = true;
    let etat = '1';
    if (this.routeId) {
      let etat = this.currentRoute.etat;
    }
    this.apiService.addRoute(lang, title, {route_id: this.routeId, description: description, youtube: youtube, medias: this.files, etat: etat}).subscribe(
      data => {
        localStorage.setItem('currentRouteId', data.data.route_id);
        this.updateCurrentRoute(toStep);
      },
      err => {
        console.log(err);
      }
    );
  }

  updateCurrentRoute(toStep) {
    this.apiService.getRoutes().subscribe(
      data => {
        this.router.navigate(['/create-circuit-'+toStep]);
        this.isLoading = false;
      },
      err => {
        console.log(err);
      }
    );
  }

  onSelect(event) {
    this.files.push(...event.addedFiles);
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  getPoints() {
    this.apiService.getPoints('fr_FR', {route_id: this.routeId}).subscribe(
      data => {
        this.currentRoutePoints = data.data;
        this.checkIfAllPointsConfigured();
      },
      err => {
        console.log(err);
      }
    );
  }

  checkIfAllPointsConfigured() {
    this.checkAllPointsConfigured = true;
    this.currentRoutePoints.forEach((element, index) => {
      if (element.statut_edit == 0) {
        this.checkAllPointsConfigured = false;
      }
    });
  }

}


function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(','),
  mime = arr[0].match(/:(.*?);/)[1],
  bstr = atob(arr[1]),
  n = bstr.length,
  u8arr = new Uint8Array(n);

  while(n--){
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, {type:mime});
}
